import styled from "@emotion/styled"
import Container from "components/Container"

const ListEightContainer = styled(Container)``

export default ListEightContainer
